import axios from 'axios';
import config from '@/config';

const { iffApi } = config.ctx;

/**
 * 人员小组管理API服务
 */
export const teamService = {
  // ==================== 小组基础 CRUD ====================

  /**
   * 查询小组列表
   * @param {Object} params
   */
  queryTeamList: (params) => axios.get(`${iffApi}/team/list`, { params: params }),

  /**
   * 分页查询小组成员列表
   * @param {Object} params
   */
  queryTeamMemberPage: (params) => axios.get(`${iffApi}/team/member/page`, { params }),

  /**
   * 新增/编辑小组
   * @param {Object} data 小组信息（uuid为空则新增）
   */
  addTeam: (data) => axios.post(`${iffApi}/team/save`, data),

  updateTeam: (data) => axios.post(`${iffApi}/team/update`, data),

  /**
   * 解散小组
   * @param {String} uuid 小组ID
   */
  deleteTeam: (uuid) => axios.delete(`${iffApi}/team/delete/${uuid}`),

  // ==================== 成员管理 ====================

  /**
   * 添加成员
   * @param {Object} data { teamId, userIds: [] }
   */
  addMembers: (data) => axios.post(`${iffApi}/team/member/add`, data),

  /**
   * 移除成员
   * @param {Object} data { teamId, userId }
   */
  removeMember: (data) => axios.post(`${iffApi}/team/member/remove`, data),

  /**
   * 设置/变更组长
   * @param {Object} data { teamId, userId }
   */
  setLeader: (data) => axios.post(`${iffApi}/team/member/setLeader`, data),

  // ==================== 候选人查询 ====================

  /**
   * 分页查询可添加的候选人列表（按岗位和部门过滤）
   * @param {Object} params { teamType, keyword }
   */
  getUserCandidatesPage: (params) => axios.get(`${iffApi}/team/user/candidates/page`, { params }),

  /**
   * 查询可添加的候选人列表（按岗位和部门过滤）
   * @param {Object} params { teamType, keyword }
   */
  getUserCandidatesList: (params) => axios.get(`${iffApi}/team/user/candidates/list`, { params })
};
